import { useEffect } from 'react';
import type { RefObject } from 'react';

export const useScrollToActiveIndex = ({
  listBoxRef,
  isListBoxOpen,
  activeIndex,
}: {
  listBoxRef: RefObject<HTMLDivElement>;
  isListBoxOpen: boolean;
  activeIndex: number;
}): void => {
  useEffect(() => {
    if (!isListBoxOpen) return;
    listBoxRef.current
      ?.querySelector(`[role=option]:nth-child(${activeIndex + 1})`)
      ?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [isListBoxOpen, activeIndex, listBoxRef]);
};
